import { render } from "./AvatarRadius.vue?vue&type=template&id=aafdeddc"
import script from "./AvatarRadius.vue?vue&type=script&lang=js"
export * from "./AvatarRadius.vue?vue&type=script&lang=js"

import "./AvatarRadius.vue?vue&type=style&index=0&id=aafdeddc&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__